import { load } from "js-yaml";
import remarkFrontmatter from "remark-frontmatter";
function frontmatter({
  onError
} = {}) {
  const remark = (processor) => processor.use(remarkFrontmatter).use(() => (tree, file) => {
    const fisrtNode = tree.children[0];
    if ((fisrtNode == null ? void 0 : fisrtNode.type) !== "yaml")
      return;
    try {
      file.frontmatter = load(fisrtNode.value);
    } catch (err) {
      onError == null ? void 0 : onError(err);
    }
  });
  return {
    remark,
    mdxRemark: remark,
    mdxHandlerList: () => (input) => {
      if ("res" in input)
        return input;
      const node = input.source;
      if (node.type === "yaml") {
        return {
          res: null
        };
      }
      if (node.type === "footnoteReference") {
        return {
          res: null
        };
      }
      if (node.type === "footnoteDefinition") {
        return {
          res: null
        };
      }
      return input;
    }
  };
}
export {
  frontmatter as default
};
